import { purchaseOrderStatusName } from '../constants/purchase-order-status.js';
/**
 * Draft cancels update Postgres directly (no workflow exists yet, since the workflow only
 * starts on issue); Issued/Shipped cancels signal the running Temporal workflow instead.
 */
export function canCancelPurchaseOrder(statusName) {
    return (statusName === purchaseOrderStatusName.DRAFT ||
        statusName === purchaseOrderStatusName.ISSUED ||
        statusName === purchaseOrderStatusName.SHIPPED);
}
//# sourceMappingURL=can-cancel-purchase-order.js.map